package com.schoolconnect.app.feature.homework

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppText
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListActionIcons
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListTypography
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminRowActionItem
import com.schoolconnect.app.designsystem.list.AdminRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.book
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.megaphone
import ischoolconnect.sharedui.generated.resources.trash
import ischoolconnect.sharedui.generated.resources.user
import org.jetbrains.compose.resources.painterResource

@Composable
fun HomeworkScreen(
    state: HomeworkUiState,
    onEvent: (HomeworkUiEvent) -> Unit,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }
    var addHomeworkVisible by remember { mutableStateOf(false) }
    var editingHomework by remember { mutableStateOf<HomeworkRowUi?>(null) }
    val displayedRows = state.rows
    val total = state.totalCount
    val window = pageWindow(state.pageIndex, state.pageSize, total)
    val pageItems = displayedRows

    AdminListPageScaffold(
        title = "Homework",
        subtitle = "Create and manage homework across your assigned classes.",
        backgroundColor = AppBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = {
            ShellTopRightActions(shellRoleLabel(shellRoleCode), shellRoleSubtitle(shellRoleCode), shellAvatarInitials(shellRoleLabel(shellRoleCode)), profileExpanded, { profileExpanded = it }, onChangeRole, onLogout)
        },
        summaryCards = {
            if (state.isLoading) {
                HomeworkSummaryCardsShimmer()
            } else {
                HomeworkMetric("Total Homework", state.totalHomework.toString(), "Across all classes", Res.drawable.book, AppPrimary, AppPrimarySoft)
                HomeworkMetric("Assigned By Me", state.assignedByMe.toString(), "My homework", Res.drawable.user, Color(0xFF4B1DDB), Color(0xFFF0EDFF))
                HomeworkMetric("All Open", state.allOpen.toString(), "Open + Overdue", Res.drawable.book, AppSuccess, AppSuccessSoft)
                HomeworkMetric("Closed", state.closed.toString(), "Completed homework", Res.drawable.circle_check, AppNavy, Color(0xFFF3F4F7))
                HomeworkMetric("Overdue", state.overdue.toString(), "Past due date", Res.drawable.ban, AppDanger, AppDangerSoft)
            }
        },
        toolbar = { HomeworkFilterPanel(state, onEvent) },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                minContentWidth = 1120.dp,
                header = { HomeworkTableHeader(state, onEvent) },
                body = {
                    if (state.isLoading) AdminListTableShimmer(columns = listOf(AdminListHeaderColumn("Homework ID", .9f), AdminListHeaderColumn("Title", 1.5f), AdminListHeaderColumn("Class", .75f), AdminListHeaderColumn("Subject", 1.1f), AdminListHeaderColumn("Assigned By", 1.1f), AdminListHeaderColumn("Assigned Date", 1f), AdminListHeaderColumn("Due Date", 1f), AdminListHeaderColumn("Status", .8f), AdminListHeaderColumn("Actions", .95f)), rowCount = state.pageSize)
                    else if (state.errorMessage.isNotBlank()) Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { AppDialogErrorMessage(state.errorMessage) }
                    else if (pageItems.isEmpty()) Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { Text("No homework found", color = AppNavy, fontWeight = FontWeight.Bold) }
                    else AdminListTableBody(items = pageItems, key = { it.backendId.ifBlank { it.homeworkId } }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                        HomeworkTableRow(
                            row = row,
                            onView = { onEvent(HomeworkUiEvent.ViewRequested(row)) },
                            onEdit = { editingHomework = row; onEvent(HomeworkUiEvent.EditRequested(row)) },
                            onDelete = { onEvent(HomeworkUiEvent.DeleteRequested(row)) },
                            onReminder = { onEvent(HomeworkUiEvent.ReminderRequested(row)) },
                            onClose = { onEvent(HomeworkUiEvent.CloseRequested(row)) }
                        )
                        HorizontalDivider(color = AppBorder)
                    }
                },
                footer = { AdminListFooter(pageText = pageFooterText(window, "homework"), pageIndex = window.pageIndex, pageCount = window.pageCount, onPageChanged = { onEvent(HomeworkUiEvent.PageChanged(it)) }, pageSize = state.pageSize, rowsPerPageExpanded = rowsPerPageExpanded, onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded }, onRowsPerPageDismiss = { rowsPerPageExpanded = false }, onPageSizeChanged = { onEvent(HomeworkUiEvent.PageSizeChanged(it)) }) }
            )
        },
        bottomAction = {
            Spacer(Modifier.weight(1f))
            AdminListPrimaryActionButton(label = "Add Homework", icon = painterResource(Res.drawable.plus), onClick = {
                addHomeworkVisible = true
                onEvent(HomeworkUiEvent.AddRequested)
            }, modifier = Modifier.padding(top = 4.dp))
        }
    )

    LaunchedEffect(state.saveGeneration) {
        if (state.saveGeneration > 0) {
            addHomeworkVisible = false
            editingHomework = null
            onEvent(HomeworkUiEvent.EditDismissed)
        }
    }

    AddHomeworkDialog(
        visible = addHomeworkVisible,
        classOptions = state.classOptionIds,
        subjectOptions = state.subjectOptionIds,
        subjectOptionsByClassId = state.subjectOptionIdsByClassId,
        teacherOptions = state.teacherOptionIds,
        teacherOptionsByClassSubject = state.teacherOptionIdsByClassSubject,
        requiresTeacherSelection = state.requiresTeacherSelection,
        isSaving = state.isSaving,
        errorMessage = state.saveErrorMessage,
        attachmentMetadata = state.attachmentMetadata,
        onSave = { onEvent(HomeworkUiEvent.SaveRequested(it)) },
        onDismiss = { if (!state.isSaving) addHomeworkVisible = false }
    )
    AddHomeworkDialog(
        visible = editingHomework != null || state.editingHomework != null,
        initialHomework = state.editingHomework ?: editingHomework,
        classOptions = state.classOptionIds,
        subjectOptions = state.subjectOptionIds,
        subjectOptionsByClassId = state.subjectOptionIdsByClassId,
        teacherOptions = state.teacherOptionIds,
        teacherOptionsByClassSubject = state.teacherOptionIdsByClassSubject,
        requiresTeacherSelection = state.requiresTeacherSelection,
        isSaving = state.isSaving,
        isLoading = state.isEditingHomeworkLoading,
        errorMessage = state.editingHomeworkError.ifBlank { state.saveErrorMessage },
        attachmentMetadata = state.attachmentMetadata,
        onSave = { onEvent(HomeworkUiEvent.SaveRequested(it)) },
        onDismiss = {
            if (!state.isSaving && !state.isEditingHomeworkLoading) {
                editingHomework = null
                onEvent(HomeworkUiEvent.EditDismissed)
            }
        }
    )
    ViewHomeworkDialog(
        homework = state.viewingHomework,
        attachmentMetadata = state.attachmentMetadata,
        isLoading = state.isViewingHomeworkLoading,
        errorMessage = state.viewingHomeworkError,
        onDismiss = { onEvent(HomeworkUiEvent.ViewDismissed) }
    )
    state.pendingDelete?.let { pending ->
        AppConfirmationDialog(
            onDismiss = { onEvent(HomeworkUiEvent.DeleteDismissed) },
            title = "Delete Homework",
            subtitle = "This will remove the homework from the active school list.",
            bodyText = "Delete ‘${pending.title}’ (${pending.homeworkId})?",
            confirmLabel = if (state.isDeleting) "Deleting…" else "Delete",
            onConfirm = { onEvent(HomeworkUiEvent.DeleteConfirmed) },
            confirmEnabled = !state.isDeleting,
            dismissEnabled = !state.isDeleting,
            tone = AppConfirmationDialogTone.Danger
        )
    }
    state.pendingClose?.let { pending ->
        AppConfirmationDialog(
            onDismiss = { onEvent(HomeworkUiEvent.CloseDismissed) },
            title = "Close Homework",
            subtitle = "Students and parents will see this homework as closed.",
            bodyText = "Close ‘${pending.title}’ (${pending.homeworkId})?",
            confirmLabel = if (state.isClosing) "Closing…" else "Close Homework",
            onConfirm = { onEvent(HomeworkUiEvent.CloseConfirmed) },
            confirmEnabled = !state.isClosing,
            dismissEnabled = !state.isClosing,
            tone = AppConfirmationDialogTone.Primary
        )
    }
}

@Composable
private fun RowScope.HomeworkMetric(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, bg: Color) {
    AdminListSummaryCard(title, value, subtitle, painterResource(icon), accent, bg, AppMuted, modifier = Modifier.weight(1f))
}

@Composable
private fun RowScope.HomeworkSummaryCardsShimmer() = AdminListSummaryCardsShimmer(
    cardCount = 5,
    cardHeight = 128.dp,
    cardShape = RoundedCornerShape(12.dp),
    contentPadding = PaddingValues(22.dp),
    iconSize = 70.dp,
    horizontalSpacing = 20.dp,
    titleWidth = 118.dp,
    titleHeight = 15.dp,
    valueWidth = 72.dp,
    valueHeight = 31.dp,
    subtitleWidth = 132.dp,
    subtitleHeight = 12.dp
)

@Composable
private fun HomeworkFilterPanel(state: HomeworkUiState, onEvent: (HomeworkUiEvent) -> Unit) {
    AppCard(modifier = Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Column(modifier = Modifier.padding(horizontal = 16.dp, vertical = 10.dp)) {
            BoxWithConstraints {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(14.dp), verticalAlignment = Alignment.Bottom) {
                    Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1.35f)) { Text("Search by Homework Title", color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 13.sp); AdminListSearchField(state.searchQuery, { onEvent(HomeworkUiEvent.SearchChanged(it)) }, "Search...", width = 260.dp, height = 44.dp, modifier = Modifier.fillMaxWidth(), surfaceColor = Color.White, borderColor = AppBorder, textColor = AppNavy) }
                    HomeworkDropdown("Class", state.filters.className.ifBlank { "All My Classes" }, state.classOptions, Modifier.weight(1.2f)) { value -> onEvent(HomeworkUiEvent.FiltersChanged(state.filters.copy(className = value, classId = state.classOptionIds[value].orEmpty(), subject = "", subjectId = ""))) }
                    HomeworkDropdown("Subject", state.filters.subject.ifBlank { "All Subjects" }, state.subjectOptionIds.keys.toList(), Modifier.weight(1.2f)) { value -> onEvent(HomeworkUiEvent.FiltersChanged(state.filters.copy(subject = value, subjectId = state.subjectOptionIds[value].orEmpty()))) }
                    HomeworkDropdown("Status", state.filters.status.ifBlank { "All" }, state.statusOptions, Modifier.weight(1.1f)) { onEvent(HomeworkUiEvent.FiltersChanged(state.filters.copy(status = it))) }
                    AppOutlinedButton(
                        onClick = { onEvent(HomeworkUiEvent.FiltersReset) },
                        modifier = Modifier.weight(.7f).height(44.dp),
                        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 12.dp),
                        colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                        shape = RoundedCornerShape(8.dp)
                    ) { Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(17.dp), tint = AppPrimary); Spacer(Modifier.width(6.dp)); Text("Clear", color = AppPrimary, maxLines = 1, softWrap = false) }
                }
            }
        }
    }
}

@Composable
private fun HomeworkDropdown(label: String, value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit) =
    AppLabeledDropdownField(
        label = label,
        value = value,
        options = options,
        onSelected = onSelected,
        modifier = modifier,
        allOptionLabel = when (label) {
            "Class" -> "All My Classes"
            "Status" -> "All"
            else -> "All"
        }
    )

@Composable
private fun HomeworkTableRow(row: HomeworkRowUi, onView: () -> Unit, onEdit: () -> Unit, onDelete: () -> Unit, onReminder: () -> Unit, onClose: () -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    Row(modifier = Modifier.fillMaxWidth().onViewDoubleClick(onView).heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        HomeworkTableCell(row.homeworkId, Modifier.weight(.9f), AppNavy, FontWeight.Medium)
        HomeworkTableCell(row.title, Modifier.weight(1.5f), AppNavy, FontWeight.Medium)
        HomeworkTableCell(row.className, Modifier.weight(.75f), AppNavy)
        HomeworkTableCell(row.subject, Modifier.weight(1.1f), AppNavy)
        HomeworkTableCell(row.assignedBy, Modifier.weight(1.1f), AppNavy)
        HomeworkTableCell(row.assignedDate, Modifier.weight(1f), AppNavy)
        HomeworkTableCell(row.dueDate, Modifier.weight(1f), if (row.status.equals("OVERDUE", ignoreCase = true)) AppDanger else AppNavy, if (row.status.equals("OVERDUE", ignoreCase = true)) FontWeight.Medium else FontWeight.Normal)
        Box(Modifier.weight(.8f), contentAlignment = Alignment.CenterStart) { HomeworkStatusChip(row.status) }
        Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
            AdminListActionIcons(
                onView = { expanded = false; onView() },
                onEdit = { expanded = false; onEdit() }
            ) {
                IconButton(onClick = { expanded = true }, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
                AdminRowActionMenu(
                    listOf(
                        listOf(AdminRowActionItem("Send Reminder", onReminder, painterResource(Res.drawable.megaphone))),
                        if (row.status.equals("Closed", ignoreCase = true)) emptyList() else listOf(AdminRowActionItem("Close Homework", onClose, painterResource(Res.drawable.circle_check))),
                        listOf(AdminRowActionItem("Delete", onDelete, painterResource(Res.drawable.trash), labelColor = AppDanger, iconTint = AppDanger))
                    ).filter { it.isNotEmpty() },
                    { expanded = false },
                    expanded = expanded
                )
            }
        }
    }
}

@Composable
private fun HomeworkTableHeader(state: HomeworkUiState, onEvent: (HomeworkUiEvent) -> Unit) {
    AdminListSortHeaderRow(listOf(
        AdminListSortColumn("Homework ID", .9f, state.sortField == HomeworkSortField.ID, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.ID)) },
        AdminListSortColumn("Title", 1.5f, state.sortField == HomeworkSortField.TITLE, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.TITLE)) },
        AdminListSortColumn("Class", .75f, state.sortField == HomeworkSortField.CLASS, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.CLASS)) },
        AdminListSortColumn("Subject", 1.1f, state.sortField == HomeworkSortField.SUBJECT, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.SUBJECT)) },
        AdminListSortColumn("Assigned By", 1.1f, state.sortField == HomeworkSortField.ASSIGNED_BY, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.ASSIGNED_BY)) },
        AdminListSortColumn("Assigned Date", 1f, state.sortField == HomeworkSortField.ASSIGNED_DATE, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.ASSIGNED_DATE)) },
        AdminListSortColumn("Due Date", 1f, state.sortField == HomeworkSortField.DUE_DATE, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.DUE_DATE)) },
        AdminListSortColumn("Status", .8f, state.sortField == HomeworkSortField.STATUS, state.sortAscending) { onEvent(HomeworkUiEvent.SortChanged(HomeworkSortField.STATUS)) }
    ), actionsLabel = "Actions", actionsWeight = .95f, actionsAlignment = Alignment.Center)
}

@Composable
private fun HomeworkHeaderCell(text: String, modifier: Modifier, center: Boolean = false) {
    AppText(
        text = text,
        modifier = modifier,
        style = MaterialTheme.typography.labelLarge,
        color = AppNavy,
        fontWeight = FontWeight.SemiBold
    )
}

@Composable
private fun HomeworkTableCell(text: String, modifier: Modifier, color: Color, weight: FontWeight = FontWeight.Normal) {
    AppText(
        text = text,
        modifier = modifier,
        style = MaterialTheme.typography.bodyMedium,
        color = color,
        fontWeight = weight
    )
}

@Composable
private fun HomeworkStatusChip(status: String) {
    val color = when (status.trim().uppercase()) {
        "OPEN" -> AppSuccess
        "DUE_SOON" -> AppWarning
        "CLOSED" -> AppNavy
        "OVERDUE" -> AppDanger
        else -> AppNavy
    }
    Text(status, color = color, fontSize = 12.sp, fontWeight = FontWeight.Medium)
}
